(function () {
    "use strict";

    // @ngInject
    function NetworkControllerCtor($scope, $injector, AppStates, OnboardingService, $state, NetworkManager, $stateParams, $timeout, $filter, WebsocketHelperService, UsersManager, AnalyticsService, NetworkOnboardingService, ModalService, ModelFactory, DeviceService, NavigationService, FacebookPixelTrackingService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkController';
        this.$scope = $scope;
        this.persistenceHash = null;
        this.NetworkManager = NetworkManager;
        this.NetworkOnboardingService= NetworkOnboardingService;
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.UsersManager = UsersManager;
        this.AnalyticsService = AnalyticsService;
        this.AppStates = AppStates;
        this.$state = $state;
        this.$timeout= $timeout;
        this.ModalService = ModalService;
        this.ModelFactory = ModelFactory;
        this.WebsocketHelperService = WebsocketHelperService;
        this.webSocketRoom = this.currUser._id + ".community";
        this.connectionsAwaitingResponseCount = 0;
        this.hasActiveNotifications = false;
        this.connections = this.ModelFactory.newNetworkUsersCollection();
        this.userSawImproveModal = true;
        this.appState.inNetworkRoute = true;
        this.confirmInfo = false;
        this.wsCallback = this.newNetworkNotification.bind(this);
        this.WebsocketHelperService.registerToRoom(this.webSocketRoom, this.wsCallback);
        this.DeviceService = DeviceService;
        this.OnboardingService = OnboardingService;
        this.NavigationService = NavigationService;
        this.$scope.$on('$destroy', function () {
            this.WebsocketHelperService.unregisterFromRoom(this.webSocketRoom);
        }.bind(this));

        this.NetworkManager.getConnections(this.connections, this.currUser._id,1,true);

        this.registerOnce(this.currUser, 'network_user_success', function gotUser() {
            if (this.currUser.first_time_on_community === null) {
                this.NetworkManager.getCurrentNetworkOnboardingStep()
                    .then(function success() {
                        if (!this.isRouteActive(this.AppStates.root_network_my_profile) && !this.isRouteActive(this.AppStates.root_core_navigation_settings_account) ) {
                            this.routeToOnBoarding();
                        }
                    }.bind(this));
            }
        }.bind(this));

        this.register(this.connections, 'success', function(successType, respStatus, respIsComplete) {

            this.connectionsAwaitingResponseCount = $filter('filter')(this.connections, {network: {connection_data: {connection_status: 'needs_response'}}}).length;

        }.bind(this));

        this.OnboardingService.triggerTrialIfNeeded();
        FacebookPixelTrackingService.trackCustomOnDesktopIfStartedMobile(this.currUser, 'MobileOnDesktop', {'currency': 'USD', 'value': 0});

        // if (this.currUser.isVendor() && !this.DeviceService.isInAppBrowser()) {
        //
        //     branch.banner({
        //         icon: 'https://res.cloudinary.com/honeybook/image/upload/v1503401759/system_web/rebranding/ios_app_icon_1x.png',
        //         title: 'HoneyBook',
        //         description: 'Turn opportunities into clients. Stay Organized. Grow your business.',
        //         rating: 0,                              // Displays a star rating out of 5. Supports half stars through increments of .5
        //         reviewCount: 0,                      // Amount of reviews your app has received next to the star rating
        //         openAppButtonText: 'Open',              // Text to show on button if the user has the app installed
        //         downloadAppButtonText: 'Get',           // Text to show on button if the user does not have the app installed
        //         sendLinkText: 'Send Link',              // Text to show on desktop button to allow users to text themselves the app
        //         phonePreviewText: '555-555-5555',      // The default phone placeholder is a US format number, localize the placeholder number with a custom placeholder with this option
        //         showiOS: true,                          // Should the banner be shown on iOS devices (both iPhones and iPads)?
        //         showiPad: false,                         // Should the banner be shown on iPads (this overrides showiOS)?
        //         showAndroid: false,                      // Should the banner be shown on Android devices?
        //         showBlackberry: false,                   // Should the banner be shown on Blackberry devices?
        //         showWindowsPhone: false,                 // Should the banner be shown on Windows Phone devices?
        //         showKindle: false,                       // Should the banner be shown on Kindle devices?
        //         showDesktop: false,                      // Should the banner be shown on desktop devices?
        //         iframe: true,                           // Show banner in an iframe, recomended to isolate Branch banner CSS
        //         disableHide: false,                     // Should the user have the ability to hide the banner? (show's X on left side)
        //         forgetHide: 1,                      // Should we show the banner after the user closes it? Can be set to true, or an integer to show again after X days
        //         respectDNT: false,                      // Should we skip showing the banner when a user's settings show 'Do Not Track'?
        //         mobileSticky: true,                    // Determines whether the mobile banner will be set `position: fixed;` (sticky) or `position: absolute;`, defaults to false *this property only applies when the banner position is 'top'
        //         desktopSticky: true,                    // Determines whether the desktop banner will be set `position: fixed;` (sticky) or `position: absolute;`, defaults to true *this property only applies when the banner position is 'top'
        //         make_new_link: false,                   // Should the banner create a new link, even if a link already exists?
        //         open_app: false                        // Should the banner try to open the app passively (without the user actively clicking) on load?
        //     }, {
        //         tags: ['smartbanner'],
        //         feature: 'smartbanner',
        //         stage: 'new user',
        //         data: {
        //             mydata: 'something',
        //             foo: 'bar',
        //             '$deeplink_path': 'open/item/1234'
        //         }
        //     });
        // }

        // $scope.$on("$destroy", function () {
        //     branch.logout();
        //     branch.closeBanner();
        // }.bind(this));

        // emitted from profile or projects feed, rebroadcast down to nav title
        $scope.$on('emitPageTitle', function(event, data) {
            this.$scope.$broadcast('broadcastPageTitle', data);
        }.bind(this));
    }

    Controllers.NetworkController = Class(Controllers.BaseController, {

        constructor: NetworkControllerCtor,

        isRouteActive: function isRouteActive(root) {
            return this.$state.current.name && this.$state.current.name.indexOf(root) !== -1;
        },

        showStickyFooter: function showStickyFooter() {
            return this.$state.includes(this.AppStates.root_network_profile) ||
                this.$state.includes(this.AppStates.root_network_my_profile) ||
                this.$state.includes(this.AppStates.root_network_project);
        },

        newNetworkNotification: function newNetworkNotification(data) {
            this.hasActiveNotifications = true;
            this.connectionsAwaitingResponseCount++;
             this.NetworkManager.getConnections(this.connections, this.currUser._id);
        },

        clickState: function clickState(toState){
            if (toState === 'connections'){
                this.$state.go(this.AppStates.root_people_creatives);
                this.connectionsAwaitingResponseCount = 0;
            }
        },

        logout: function logout() {
            this.UsersManager.logout().then(function afterLogout() {
                this.AnalyticsService.unidentify();
                this.goToState(this.AppStates.root_core_login);
            }.bind(this));
        },

        openWorkflowLinkModal: function openWorkflowLinkModal() {
            //yona yona
            this.ModalService.openNetworkHelloLinkModal();
        },

        showIntro: function showIntro() {
            this.ModalService.openNetworkOnboardingIntroductionModal().then(function ok() {
                this.currUser.network_onboarding_container.network_onboarding_step = this.NetworkOnboardingService.OnboardingSteps.welcomeIntro;
                this.NetworkManager.setNetworkOnboardingStepComplete(this.NetworkOnboardingService.OnboardingSteps.welcomeIntro);
            }.bind(this));
        },

        routeToOnBoarding: function routeToOnBoarding(){

            if(!this.currUser.network_onboarding_container) {
                this.showIntro();
            } else if(this.currUser.network_onboarding_container.network_onboarding_step === this.NetworkOnboardingService.OnboardingSteps.welcomeIntro) {
                this.$state.go(this.AppStates.root_network_edit_profile);
            }

        },

        navigateToPipeline: function navigateToPipeline() {
            if (this.NetworkOnboardingService.isHBUnlocked(this.currUser)) {
                this.goToState(this.AppStates.root_core_navigation_pipeline);
            } else {
                this.openWorkflowLinkModal();
            }
        },

        createProject: function createProject() {
            this.goToState(this.AppStates.root_network_create_project);
        },

        isNavSecondLevelNoTitle: function isNavSecondLevelNoTitle() {
            return Boolean(this.$state.current.data.secondLevelNavNoTitle);
        },
        
        isNavSecondLevelWithTitle: function isNavSecondLevelWithTitle() {
            return Boolean(this.$state.current.data.secondLevelNavWithTitle);
        },

        isNavSinglePage: function isNavSinglePage() {
            return Boolean(this.$state.current.data.singlePageNav);
        }
    });
}());
